module.exports = __webpack_public_path__ + "img/76a990b.jpg";